<template>
  <v-dialog
    v-model="open"
    persistent
    scrollable
    max-width="530px"
  >
    <v-card>
      <v-toolbar color="primary" dark class="pl-6">
        <span class="text-h6 text-center">
          Ordenação de Campos Adicionais
        </span>
      </v-toolbar>

      <v-card-text style="height: auto">
        <div
          v-for="(type, i) in _section.ticket_types?.filter(t => t.additional_fields?.length)"
          :key="i"
          class="mb-5"
        >
          <div class="text-h7">
            <strong>Tipo de Ingresso: </strong>
            <span> {{ type.name }} </span>
          </div>
          <vue-draggable-next
            tag="div"
            :list="type.additional_fields"
            class="list-group"
            :handle="`.handle-${i}`"
            item-key="label"
          >
            <v-card
              v-for="element, j in type.additional_fields"
              :key="j"
              class="mx-auto ma-3"
              elevation="2"
            >
              <div class="d-flex align-center justify-center ma-2 ml-3">
                <p class="flex-grow-1 font-weight-medium">
                  {{ element.label }}
                </p>
                <v-icon
                  :class="`handle-${i}`"
                  style="cursor: pointer"
                  start
                  color="grey-darken-1"
                  icon="fa-regular fa-sort"
                />
              </div>
            </v-card>
          </vue-draggable-next>
        </div>
      </v-card-text>

      <v-divider />

      <v-card-actions>
        <v-spacer />
        <v-btn
          color="red darken-1"
          variant="text"
          :disabled="loader.loading"
          @click="cancel"
        >
          Cancelar
        </v-btn>
        <v-btn
          color="green darken-1"
          variant="text"
          :disabled="loader.loading"
          @click="submit"
        >
          Salvar
        </v-btn>
      </v-card-actions>
      <v-progress-linear v-show="loader.loading" indeterminate color="primary" />
    </v-card>
  </v-dialog>
</template>
<script lang="ts" setup>
import AdditionalFieldService from '@/services/AdditionalFieldService'
import { useLoader } from '@/stores/loader'
import { useSnackBar } from '@/stores/snackbar'
import AdditionalField from '@/types/AdditionalField'
import Section from '@/types/Section'
import { ref } from 'vue'
import { VueDraggableNext } from 'vue-draggable-next'

const loader = useLoader()
const snackbar = useSnackBar()

const emit = defineEmits([ 'close' ])

const section = defineModel<Section>('section', { required: true })

const open = ref(true)

const _section = ref<Section>(JSON.parse(JSON.stringify(section.value)))

function cancel() {
  emit('close')
}

async function submit() {
  const fields = (_section.value.ticket_types ?? []).flatMap((tt) => {
    tt.additional_fields?.forEach((f, i) => f.order = i)
    return tt.additional_fields
  })

  try {
    loader.increment()

    await (new AdditionalFieldService()).updateSortingOrder(fields as AdditionalField[])

    section.value.ticket_types = _section.value.ticket_types

    snackbar.show('Campos adicionais reordenados com sucesso!', 'success')

    emit('close')
  } finally {
    loader.decrement()
  }
}
</script>
